import './ProductsList.sass'
import { withRouter } from 'react-router-dom'
import BrandsPanel from '../Brands/BrandsPanel/BrandsPanel'
import ProductsTable from './ProductsTable/ProductsTable'
import { useContext, useEffect } from 'react'
import ProductsManager from './ProductsManager/ProductsManager'
import { AuthContext } from '../../../../App'

function ProductsList({ ...router }) {
  const { brandId, productId } = router.match.params

  const { setPageTitle } = useContext(AuthContext)
  useEffect(() => setPageTitle('Товари'))

  return (
    <div className="ProductsList">
      <BrandsPanel onClickPath={'/products/list'} routerIdName="brandId" />
      {brandId && !productId && <ProductsTable brandId={brandId} />}
      {brandId && productId && <ProductsManager />}
    </div>
  )
}

export default withRouter(ProductsList)
